var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1330,
    height: 432,
    viewBox: "0 0 1330 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.99 247H207.99L192.99 274L207.99 301H238.99L253.99 274L238.99 247Z",
    fill: "url(#paint0_linear_403_3686)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.49 247H106.49L91.4902 274L106.49 301H137.49L152.49 274L137.49 247Z",
    fill: "url(#paint1_linear_403_3686)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4902 218.5H55.4902L40.4902 245.5L55.4902 272.5H86.4902L101.49 245.5L86.4902 218.5Z",
    fill: "url(#paint2_linear_403_3686)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4902 214.5L86.4902 214.5L101.49 187.5L86.4902 160.5L55.4902 160.5L40.4902 187.5L55.4902 214.5Z",
    fill: "url(#paint3_linear_403_3686)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.49 214.5L288.49 214.5L303.49 187.5L288.49 160.5L257.49 160.5L242.49 187.5L257.49 214.5Z",
    fill: "url(#paint4_linear_403_3686)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.49 184.5L137.49 184.5L152.49 157.5L137.49 130.5L106.49 130.5L91.4902 157.5L106.49 184.5Z",
    fill: "url(#paint5_linear_403_3686)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.49 184.5L239.49 184.5L254.49 157.5L239.49 130.5L208.49 130.5L193.49 157.5L208.49 184.5Z",
    fill: "url(#paint6_linear_403_3686)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.49 156.5L188.49 156.5L203.49 129.5L188.49 102.5L157.49 102.5L142.49 129.5L157.49 156.5Z",
    fill: "url(#paint7_linear_403_3686)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M288.49 218.5H257.49L242.49 245.5L257.49 272.5H288.49L303.49 245.5L288.49 218.5Z",
    fill: "url(#paint8_linear_403_3686)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.753 276.5H156.228L140.49 303.5L156.228 330.5H188.753L204.49 303.5L188.753 276.5Z",
    fill: "url(#paint9_linear_403_3686)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.572 385.5H218.408L213.49 394L218.408 402.5H228.572L233.49 394L228.572 385.5Z",
    fill: "url(#paint10_linear_403_3686)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.408 46.5L127.572 46.5L132.49 38L127.572 29.5L117.408 29.5L112.49 38L117.408 46.5Z",
    fill: "url(#paint11_linear_403_3686)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M279.572 356.5H269.408L264.49 365L269.408 373.5H279.572L284.49 365L279.572 356.5Z",
    fill: "url(#paint12_linear_403_3686)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4083 75.5L76.5722 75.5L81.4902 67L76.5722 58.5L66.4083 58.5L61.4902 67L66.4083 75.5Z",
    fill: "url(#paint13_linear_403_3686)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5722 356.5H66.4083L61.4902 365L66.4083 373.5H76.5722L81.4902 365L76.5722 356.5Z",
    fill: "url(#paint14_linear_403_3686)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M269.408 75.5L279.572 75.5L284.49 67L279.572 58.5L269.408 58.5L264.49 67L269.408 75.5Z",
    fill: "url(#paint15_linear_403_3686)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M127.572 385.5H117.408L112.49 394L117.408 402.5H127.572L132.49 394L127.572 385.5Z",
    fill: "url(#paint16_linear_403_3686)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M218.408 46.5L228.572 46.5L233.49 38L228.572 29.5L218.408 29.5L213.49 38L218.408 46.5Z",
    fill: "url(#paint17_linear_403_3686)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M178.572 414.5H168.408L163.49 423L168.408 431.5H178.572L183.49 423L178.572 414.5Z",
    fill: "url(#paint18_linear_403_3686)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M167.408 17.5L177.572 17.5L182.49 9L177.572 0.5L167.408 0.499999L162.49 9L167.408 17.5Z",
    fill: "url(#paint19_linear_403_3686)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M184.425 344.5H161.556L150.49 364L161.556 383.5H184.425L195.49 364L184.425 344.5Z",
    fill: "url(#paint20_linear_403_3686)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M161.556 88.5L184.425 88.5L195.49 69L184.425 49.5L161.556 49.5L150.49 69L161.556 88.5Z",
    fill: "url(#paint21_linear_403_3686)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M286.425 286.5H263.556L252.49 306L263.556 325.5H286.425L297.49 306L286.425 286.5Z",
    fill: "url(#paint22_linear_403_3686)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M131.638 318.5H113.343L104.49 334L113.343 349.5H131.638L140.49 334L131.638 318.5Z",
    fill: "url(#paint23_linear_403_3686)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6214 291.5H63.3591L55.4902 305.5L63.3591 319.5H79.6214L87.4902 305.5L79.6214 291.5Z",
    fill: "url(#paint24_linear_403_3686)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5497 141.542L87.6808 127.458L79.4909 113.644L63.4321 113.458L55.3009 127.542L63.4909 141.356L79.5497 141.542Z",
    fill: "url(#paint25_linear_403_3686)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M333.13 258.5H315.851L307.49 273.5L315.851 288.5H333.13L341.49 273.5L333.13 258.5Z",
    fill: "url(#paint26_linear_403_3686)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1296 258.5H12.8509L4.49023 273.5L12.8509 288.5H30.1296L38.4902 273.5L30.1296 258.5Z",
    fill: "url(#paint27_linear_403_3686)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1608 172.482L38.8001 157.518L29.9901 142.778L12.8194 142.518L4.18003 157.482L12.9901 172.223L30.1608 172.482Z",
    fill: "url(#paint28_linear_403_3686)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M307.671 157.518L316.31 172.482L333.481 172.223L342.291 157.482L333.651 142.518L316.481 142.778L307.671 157.518Z",
    fill: "url(#paint29_linear_403_3686)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.146 199.5H18.8345L9.49023 216.5L18.8345 233.5H38.146L47.4902 216.5L38.146 199.5Z",
    fill: "url(#paint30_linear_403_3686)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M327.146 199.5H307.834L298.49 216.5L307.834 233.5H327.146L336.49 216.5L327.146 199.5Z",
    fill: "url(#paint31_linear_403_3686)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M232.638 318.5H214.343L205.49 334L214.343 349.5H232.638L241.49 334L232.638 318.5Z",
    fill: "url(#paint32_linear_403_3686)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M214.343 113.5L232.638 113.5L241.49 98L232.638 82.5L214.343 82.5L205.49 98L214.343 113.5Z",
    fill: "url(#paint33_linear_403_3686)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M113.343 113.5L131.638 113.5L140.49 98L131.638 82.5L113.343 82.5L104.49 98L113.343 113.5Z",
    fill: "url(#paint34_linear_403_3686)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M263.556 145.5L286.425 145.5L297.49 126L286.425 106.5L263.556 106.5L252.49 126L263.556 145.5Z",
    fill: "url(#paint35_linear_403_3686)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M252.49 218.5H90.4902L104.376 243H138.833L155.805 271.5H188.719L205.176 243H238.605L252.49 218.5Z",
    fill: "url(#paint36_linear_403_3686)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4902 214.5L252.49 214.5L238.69 190L204.446 190L187.579 161.5L154.868 161.5L138.512 190L105.29 190L91.4902 214.5Z",
    fill: "url(#paint37_linear_403_3686)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M537.631 114.824C558.943 114.824 577.567 119.048 593.503 127.496C609.439 135.944 621.727 147.848 630.367 163.208C639.199 178.376 643.615 195.944 643.615 215.912C643.615 235.688 639.199 253.256 630.367 268.616C621.727 283.976 609.343 295.88 593.215 304.328C577.279 312.776 558.751 317 537.631 317H461.887V114.824H537.631ZM534.463 274.376C553.087 274.376 567.583 269.288 577.951 259.112C588.319 248.936 593.503 234.536 593.503 215.912C593.503 197.288 588.319 182.792 577.951 172.424C567.583 162.056 553.087 156.872 534.463 156.872H511.135V274.376H534.463ZM695.905 139.592C687.265 139.592 680.161 137.096 674.593 132.104C669.217 126.92 666.529 120.584 666.529 113.096C666.529 105.416 669.217 99.08 674.593 94.088C680.161 88.904 687.265 86.312 695.905 86.312C704.353 86.312 711.265 88.904 716.641 94.088C722.209 99.08 724.993 105.416 724.993 113.096C724.993 120.584 722.209 126.92 716.641 132.104C711.265 137.096 704.353 139.592 695.905 139.592ZM720.385 156.296V317H671.137V156.296H720.385ZM907.563 234.056C907.563 238.664 907.275 243.464 906.699 248.456H795.243C796.011 258.44 799.179 266.12 804.747 271.496C810.507 276.68 817.515 279.272 825.771 279.272C838.059 279.272 846.603 274.088 851.403 263.72H903.819C901.131 274.28 896.235 283.784 889.131 292.232C882.219 300.68 873.483 307.304 862.923 312.104C852.363 316.904 840.555 319.304 827.499 319.304C811.755 319.304 797.739 315.944 785.451 309.224C773.163 302.504 763.563 292.904 756.651 280.424C749.739 267.944 746.283 253.352 746.283 236.648C746.283 219.944 749.643 205.352 756.363 192.872C763.275 180.392 772.875 170.792 785.163 164.072C797.451 157.352 811.563 153.992 827.499 153.992C843.051 153.992 856.875 157.256 868.971 163.784C881.067 170.312 890.475 179.624 897.195 191.72C904.107 203.816 907.563 217.928 907.563 234.056ZM857.163 221.096C857.163 212.648 854.283 205.928 848.523 200.936C842.763 195.944 835.563 193.448 826.923 193.448C818.667 193.448 811.659 195.848 805.899 200.648C800.331 205.448 796.875 212.264 795.531 221.096H857.163ZM1023.11 275.24V317H998.056C980.2 317 966.28 312.68 956.296 304.04C946.312 295.208 941.32 280.904 941.32 261.128V197.192H921.736V156.296H941.32V117.128H990.568V156.296H1022.82V197.192H990.568V261.704C990.568 266.504 991.72 269.96 994.024 272.072C996.328 274.184 1000.17 275.24 1005.54 275.24H1023.11ZM1176.4 281.288H1100.94L1088.85 317H1037.3L1110.45 114.824H1167.47L1240.62 317H1188.5L1176.4 281.288ZM1163.73 243.272L1138.67 169.256L1113.9 243.272H1163.73ZM1312.14 114.824V317H1262.89V114.824H1312.14Z",
    fill: "url(#paint38_linear_403_3686)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_3686",
    x1: 204.367,
    y1: 241.838,
    x2: 257.758,
    y2: 289.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_3686",
    x1: 102.867,
    y1: 241.838,
    x2: 156.258,
    y2: 289.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_403_3686",
    x1: 51.8672,
    y1: 213.338,
    x2: 105.258,
    y2: 260.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_403_3686",
    x1: 90.1132,
    y1: 219.662,
    x2: 36.7227,
    y2: 172.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_403_3686",
    x1: 292.113,
    y1: 219.662,
    x2: 238.723,
    y2: 172.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_403_3686",
    x1: 141.113,
    y1: 189.662,
    x2: 87.7227,
    y2: 142.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_403_3686",
    x1: 243.113,
    y1: 189.662,
    x2: 189.723,
    y2: 142.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_403_3686",
    x1: 192.113,
    y1: 161.662,
    x2: 138.723,
    y2: 114.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_403_3686",
    x1: 253.867,
    y1: 213.338,
    x2: 307.258,
    y2: 260.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_403_3686",
    x1: 152.427,
    y1: 271.338,
    x2: 206.064,
    y2: 321.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_403_3686",
    x1: 217.22,
    y1: 383.875,
    x2: 234.097,
    y2: 399.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_403_3686",
    x1: 128.76,
    y1: 48.125,
    x2: 111.884,
    y2: 32.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_403_3686",
    x1: 268.22,
    y1: 354.875,
    x2: 285.097,
    y2: 370.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_403_3686",
    x1: 77.7601,
    y1: 77.125,
    x2: 60.8838,
    y2: 61.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_403_3686",
    x1: 65.2204,
    y1: 354.875,
    x2: 82.0966,
    y2: 370.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_403_3686",
    x1: 280.76,
    y1: 77.125,
    x2: 263.884,
    y2: 61.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_403_3686",
    x1: 116.22,
    y1: 383.875,
    x2: 133.097,
    y2: 399.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_403_3686",
    x1: 229.76,
    y1: 48.125,
    x2: 212.884,
    y2: 32.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_403_3686",
    x1: 167.22,
    y1: 412.875,
    x2: 184.097,
    y2: 428.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_403_3686",
    x1: 178.76,
    y1: 19.125,
    x2: 161.884,
    y2: 3.53944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_403_3686",
    x1: 158.883,
    y1: 340.772,
    x2: 197.532,
    y2: 375.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_403_3686",
    x1: 187.097,
    y1: 92.2279,
    x2: 148.448,
    y2: 57.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_403_3686",
    x1: 260.883,
    y1: 282.772,
    x2: 299.532,
    y2: 317.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_403_3686",
    x1: 111.205,
    y1: 315.537,
    x2: 141.945,
    y2: 343.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_403_3686",
    x1: 61.4585,
    y1: 288.824,
    x2: 89.1792,
    y2: 313.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_403_3686",
    x1: 90.949,
    y1: 127.15,
    x2: 55.5513,
    y2: 138.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_403_3686",
    x1: 313.832,
    y1: 255.632,
    x2: 343.504,
    y2: 282.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_403_3686",
    x1: 10.8315,
    y1: 255.632,
    x2: 40.5044,
    y2: 282.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_403_3686",
    x1: 42.2933,
    y1: 157.203,
    x2: 4.59489,
    y2: 169.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_403_3686",
    x1: 314.836,
    y1: 175.665,
    x2: 322.862,
    y2: 136.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_403_3686",
    x1: 16.5775,
    y1: 196.25,
    x2: 50.1491,
    y2: 225.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_403_3686",
    x1: 305.578,
    y1: 196.25,
    x2: 339.149,
    y2: 225.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_403_3686",
    x1: 212.205,
    y1: 315.537,
    x2: 242.945,
    y2: 343.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_403_3686",
    x1: 234.776,
    y1: 116.463,
    x2: 204.036,
    y2: 88.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_403_3686",
    x1: 133.776,
    y1: 116.463,
    x2: 103.036,
    y2: 88.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_403_3686",
    x1: 289.097,
    y1: 149.228,
    x2: 250.448,
    y2: 114.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_403_3686",
    x1: 120.705,
    y1: 213.434,
    x2: 158.188,
    y2: 303.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_403_3686",
    x1: 222.462,
    y1: 219.566,
    x2: 184.815,
    y2: 129.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_403_3686",
    x1: 609.246,
    y1: -41.2941,
    x2: 994.898,
    y2: 579.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3eaa2ee6faf041c9a43a2afb0986be37.svg";
export { ForwardRef as ReactComponent };